import type { ActionTree } from 'vuex';
import type { Entity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';
import type { RootState } from '../../store/root.types';
import { EntityService } from '../../api/entity/services/entity.service';
import { EntityAction, EntityMutation } from './entity.types';
import type { EntityState } from './entity.types';

export const actions: ActionTree<EntityState, RootState> = {
  async [EntityAction.Load]({ dispatch }) {
    try {
      const entity: Entity = await EntityService.getEntity();
      dispatch(EntityAction.LoadSuccess, entity);
    } catch (e) {
      console.error(e);
    }
  },
  [EntityAction.LoadSuccess]({ commit }, entity: Entity) {
    commit(EntityMutation.SetEntity, entity);
  },
};
